<template>
	<div>
		<case-form :schema="smokingStatus" class="mt6" />

		<div class="xs-12 fs4 fw7 mt6 mb2">
			请提供详细资料
		</div>

		<div class="xs-12 fs4 fw7 mt6 mb2">香烟</div>
		<case-form :schema="schemaCigarettes" />

		<div class="xs-12 fs4 fw7 mt6 mb2">雪茄</div>
		<case-form :schema="schemaCigars" />

		<div class="xs-12 fs4 fw7 mt6 mb2">其他</div>
		<case-form :schema="schemaOthers" />

		<div class="fs4 fw7 lh125 mt6 mb2">你曾今有过:</div>
		<case-form :schema="schemaPersonalHealth" />

		<div class="xs-12 fs4 fw7 mb2 mt6">
			如以上任何问题选择"是"，请提供详细资料：
		</div>
		<j-accordion
			v-for="i in 7"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaDetails(i)" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	data() {
		return {}
	},

	computed: {
		smokingStatus() {
			return [
				{
					label:
						"您曾否吸食任何形式的烟草或尼古丁产品（包括香烟、雪茄、小雪茄、烟斗、嚼烟、尼古丁贴片 或尼古丁香口糖）?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0useTobaccoOrNicotineProductCN`,
					props: {
						suggest: {
							typeIncludes: `useTobaccoOrNicotineProductCN`
						},
						createOptions: {
							type: `useTobaccoOrNicotineProductCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaCigarettes() {
			return [
				{
					label: `产品`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cigaretteProductUsedCN`,
					props: {
						suggest: {
							typeIncludes: `cigaretteProductUsedCN`
						},
						createOptions: {
							type: `cigaretteProductUsedCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `数量／频密度`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cigaretteAmountFrequencyCN`,
					props: {
						suggest: {
							typeIncludes: `cigaretteAmountFrequencyCN`
						},
						createOptions: {
							type: `cigaretteAmountFrequencyCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `现在`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0smokeCigaretteCurrentlyCN`,
					props: {
						suggest: {
							typeIncludes: `smokeCigaretteCurrentlyCN`
						},
						createOptions: {
							type: `smokeCigaretteCurrentlyCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `过去`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0smokeCigaretteInPastCN`,
					props: {
						suggest: {
							typeIncludes: `smokeCigaretteInPastCN`
						},
						createOptions: {
							type: `smokeCigaretteInPastCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `上次使用日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cigaretteDateLastUsedCN`,
					props: {
						suggest: {
							typeIncludes: `cigaretteDateLastUsedCN`
						},
						createOptions: {
							type: `cigaretteDateLastUsedCN`,
							dataType: "date"
						}
					}
				}
			]
		},

		schemaCigars() {
			return [
				{
					label: `产品`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cigarProductUsedCN`,
					props: {
						suggest: {
							typeIncludes: `cigarProductUsedCN`
						},
						createOptions: {
							type: `cigarProductUsedCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `数量／频密度`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cigarAmountFrequencyCN`,
					props: {
						suggest: {
							typeIncludes: `cigarAmountFrequencyCN`
						},
						createOptions: {
							type: `cigarAmountFrequencyCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `现在`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0smokeCigarCurrentlyCN`,
					props: {
						suggest: {
							typeIncludes: `smokeCigarCurrentlyCN`
						},
						createOptions: {
							type: `smokeCigarCurrentlyCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `过去`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0smokeCigarInPastCN`,
					props: {
						suggest: {
							typeIncludes: `smokeCigarInPastCN`
						},
						createOptions: {
							type: `smokeCigarInPastCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `上次使用日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cigarDateLastUsedCN`,
					props: {
						suggest: {
							typeIncludes: `cigarDateLastUsedCN`
						},
						createOptions: {
							type: `cigarDateLastUsedCN`,
							dataType: "date"
						}
					}
				}
			]
		},

		schemaOthers() {
			return [
				{
					label: `产品`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherProductUsedCN`,
					props: {
						suggest: {
							typeIncludes: `otherProductUsedCN`
						},
						createOptions: {
							type: `otherProductUsedCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `数量／频密度`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherAmountFrequencyCN`,
					props: {
						suggest: {
							typeIncludes: `otherAmountFrequencyCN`
						},
						createOptions: {
							type: `otherAmountFrequencyCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `现在`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0smokeOtherCurrentlyCN`,
					props: {
						suggest: {
							typeIncludes: `smokeOtherCurrentlyCN`
						},
						createOptions: {
							type: `smokeOtherCurrentlyCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `过去`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0smokeOtherInPastCN`,
					props: {
						suggest: {
							typeIncludes: `smokeOtherInPastCN`
						},
						createOptions: {
							type: `smokeOtherInPastCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `上次使用日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDateLastUsedCN`,
					props: {
						suggest: {
							typeIncludes: `otherDateLastUsedCN`
						},
						createOptions: {
							type: `otherDateLastUsedCN`,
							dataType: "date"
						}
					}
				}
			]
		},
		schemaPersonalHealth() {
			return [
				{
					label: `15a) 胸痛、心脏病、呼吸短促、心脏杂音、高血压、中风、心率不正、心脏或动?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15ACN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15ACN`
						},
						createOptions: {
							type: `healthHistoryQuestion15ACN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15b) 糖尿病、高血糖或葡萄糖耐量异常或任何内分泌腺疾病？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15BCN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15BCN`
						},
						createOptions: {
							type: `healthHistoryQuestion15BCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15c) 精神失常、情绪失控、精神崩溃、抽搐、癫痫、瘫痪或任何脑部或神经系统 ?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15CCN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15CCN`
						},
						createOptions: {
							type: `healthHistoryQuestion15CCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15d) 关节炎、痛风症或任何骨骼、关节肌肉或皮肤异常的情况？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15DCN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15DCN`
						},
						createOptions: {
							type: `healthHistoryQuestion15DCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15e) 哮喘、支气管炎、肺炎或肺部不正常情况？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15ECN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15ECN`
						},
						createOptions: {
							type: `healthHistoryQuestion15ECN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15f) 肝硬化、肝炎、胃溃疡、结肠炎、憩室炎、回肠炎或其他肝、胆、胰、胃或肠脏疾病？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15FCN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15FCN`
						},
						createOptions: {
							type: `healthHistoryQuestion15FCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15g) 前列腺疾病或睪丸疾病、子宫、子宫颈、卵巢或乳房疾病？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15GCN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15GCN`
						},
						createOptions: {
							type: `healthHistoryQuestion15GCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15h) 贫血、白血病、血凝功能失常、血小板功能失常、血液感染或多源失血？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15HCN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15HCN`
						},
						createOptions: {
							type: `healthHistoryQuestion15HCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15i) 尿道或肾功能失常、尿液带有糖分、血蛋白或血液？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15ICN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15ICN`
						},
						createOptions: {
							type: `healthHistoryQuestion15ICN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15j) 癌症或肿瘤？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15JCN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15JCN`
						},
						createOptions: {
							type: `healthHistoryQuestion15JCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15k) 曾否在医院或任何健康护理设施接受手术，或入院接受观察，或接受任何疾病的治疗，或诊断测试，包括投保所需的运动压力心电图?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15KCN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15KCN`
						},
						createOptions: {
							type: `healthHistoryQuestion15KCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15l) 是否患上后天免疫力缺乏症（俗称艾滋病）或对后天免疫力缺乏症病毒的血液测试呈阳性反应（即 HIV）？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15LCN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15LCN`
						},
						createOptions: {
							type: `healthHistoryQuestion15LCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15m) 其他健康问题或需药物治疗的情况？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15MCN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15MCN`
						},
						createOptions: {
							type: `healthHistoryQuestion15MCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `16a) 服用或使用安非他明、巴比士酸盐（治疗癫痫症的药物〉、大麻、可卡因、迷幻药、麻醉剂或任何
非医生签发的处方药物？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion16ACN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion16ACN`
						},
						createOptions: {
							type: `healthHistoryQuestion16ACN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `16b) 被建议限制或停止使用酒精或某些药物、寻求或接受治疗或参与酒精或药物使用辅导小组？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion16BCN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion16BCN`
						},
						createOptions: {
							type: `healthHistoryQuestion16BCN`,
							dataType: "boolean"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaDetails(i) {
			return [
				{
					label: `问题号码`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestionNumberFor${i}CN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestionNumberFor${i}CN`
						},
						createOptions: {
							type: `healthHistoryQuestionNumberFor${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryDateFor${i}CN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryDateFor${i}CN`
						},
						createOptions: {
							type: `healthHistoryDateFor${i}CN`,
							dataType: "date"
						}
					}
				},
				{
					label: `详情包括诊断、治疗、完成的测试、结果、目前情况`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryDetailsFor${i}CN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryDetailsFor${i}CN`
						},
						createOptions: {
							type: `healthHistoryDetailsFor${i}CN`,
							dataType: "date"
						}
					}
				},
				{
					label: `医生或医院的名称、地址、国家及电话号码`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryDoctorFor${i}CN`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryDoctorFor${i}CN`
						},
						createOptions: {
							type: `healthHistoryDoctorFor${i}CN`,
							dataType: "date"
						}
					}
				}
			]
		}
	}
}
</script>
